import Image from 'next/image'
import { ArrowRight } from 'lucide-react'
import Button from '@/components/ui/Button'
import TrackingLink from '@/components/TrackingLink'
import SectionLayout from '../SectionLayout'
import TestimonialCards from '../TestimonialCard'
import { CustomerStoriesSectionProps } from './CustomerStoriesSection.types'

const CustomerStoriesSection: React.FC<CustomerStoriesSectionProps> = ({
  tracking,
  showOverlay = true,
  showFeaturedCaseStudy = true,
}) => {
  const sectionClassName = showOverlay
    ? 'relative mx-auto max-w-8xl overflow-hidden border !border-b-0 !border-t-0 border-dashed border-[var(--l2-border)] bg-blur-ellipse-388'
    : 'relative mx-auto max-w-8xl overflow-hidden border !border-b-0 !border-t-0 border-dashed border-[var(--l2-border)]'

  return (
    <>
      <section className={sectionClassName}>
        {showOverlay && (
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[var(--l1-background-60)] via-[color-mix(in_srgb,var(--l1-background),transparent_75%)] to-[color-mix(in_srgb,var(--l1-background),transparent_10%)]" />
        )}

        {showFeaturedCaseStudy && (
          <div className="relative">
            <div className="container pb-16">
              <div className="flex flex-col gap-6 py-32">
                <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
                  <div className="flex flex-col items-center gap-12 text-2xl font-medium text-[var(--callout-sienna-title)]">
                    <Image
                      src="/img/case_study/logos/shaped-logo.svg"
                      alt="Shaped"
                      width={100}
                      height={100}
                    />
                    Every single time we have an issue, SigNoz is always the first place to check.
                    It was super straightforward to migrate - just updating the exporter
                    configuration, basically three lines of code.
                    <span className="text-sm text-[var(--l2-foreground)]">
                      <span className="font-semibold">Karl Lyons</span> <br /> Senior SRE, Shaped
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <SectionLayout variant="bordered" className="!mx-auto p-0 max-md:-mb-[3rem]">
        <div className="container pb-16">
          <TestimonialCards excludeLastCard={!showOverlay} />

          <div
            className={
              showOverlay
                ? 'z-5 relative -mt-[25rem] flex h-[25rem] items-end justify-center bg-gradient-to-t from-[var(--l1-background)] to-transparent py-6 max-md:py-16'
                : 'flex items-center justify-center py-6 max-md:py-16'
            }
          >
            {tracking ? (
              <Button variant="secondary" className="flex items-center gap-2" asChild>
                <TrackingLink
                  href="/customers/"
                  clickType="Secondary CTA"
                  clickName={tracking.clickName}
                  clickLocation={tracking.clickLocation}
                  clickText="Read customer stories"
                >
                  Read customer stories
                  <ArrowRight size={14} />
                </TrackingLink>
              </Button>
            ) : (
              <Button variant="secondary" className="flex items-center gap-2" href="/customers/">
                Read customer stories
                <ArrowRight size={14} />
              </Button>
            )}
          </div>
        </div>
      </SectionLayout>
    </>
  )
}

export default CustomerStoriesSection
